import Button, { ButtonVariantType } from '@dealroadshow/uikit/core/components/Button';
import {
  usePortfolioMonitorContext,
} from '@/finsight/application/PortfolioMonitor/PortfolioMonitorContext';

import styles from './styles.scss';

const GetStartedButton = () => {
  const { setIsFormOpened } = usePortfolioMonitorContext();

  const openForm = () => setIsFormOpened(true);

  return (
    <Button
      dataTest="cusipPortfolioGetStartedButton"
      variant={ ButtonVariantType.action }
      className={ styles.getStartedButton }
      onClick={ openForm }
    >
      Get Started
    </Button>
  );
};

export default GetStartedButton;
